import mime from "mime"

import { axiosWrapperV2 } from "../api/APIWrapper"
import api from "../../../api/axios"

const urlCreator = window.URL || window.webkitURL



const handleDownloadOrView = async ({ action, user, url, name, type }) => {
	const extension = mime.getExtension(type)
	if (!name.endsWith(`.${extension}`)) name = `${name}.${extension}`

	let data;

	if (url?.includes("static")) {
		const response = await api.get(url, { responseType: "arraybuffer" })
		data = response?.data
	} else if (Boolean(user)) {
		const response = await api.get(url, {
			responseType: "arraybuffer",
			headers: {
				Authorization: `Bearer ${user.token}`
			}
		})

		data = response?.data
	} else {
		const response = await axiosWrapperV2.send({
			url,
			method: "GET",
			responseType: "arraybuffer"
		})

		data = response?.data
	}

	const arrayBufferView = new Uint8Array(data)
	const blob = new Blob([arrayBufferView], { type })

	const imageUrl = urlCreator.createObjectURL(blob)
	if (action === "download") {
		const a = document.createElement("a")
		a.href = imageUrl
		a.download = name

		document.body.appendChild(a)
		a.click()
		document.body.removeChild(a)
	} else if (action === "view") {
		const button = document.createElement("button")
		button.addEventListener("click", function (e) {
			window.open(imageUrl, "_blank", "popup=true")
		})
		document.body.appendChild(button)
		button.click()
		document.body.removeChild(button)
	}
	urlCreator.revokeObjectURL(imageUrl)
}
export default handleDownloadOrView
